import { EstimationInput } from '../calculator-widget/App';
import { getAppLinks } from './appLinks';

const appLinks = getAppLinks();

export const getBusinessDefaultURL = () => {
  if (!document) return '';
  const paramsObj = new URLSearchParams(document.location.search);
  let paramsString = getParams(paramsObj);
  const baseURL = `${appLinks.carbonClickBusinessEmissionsUrl}?business`;

  return encodeURI(`${baseURL}${paramsString ? `&${paramsString}` : ''}`);
};

export const getBusinessDefaultURLWithMerchantCode = () => {
  if (!document) return '';
  const paramsObj = new URLSearchParams(document.location.search);
  return `${
    appLinks.carbonClickBusinessEmissionsUrl
  }?business&merchantReferrerCode=${encodeURIComponent(
    paramsObj.get('merchantReferrerCode') || '',
  )}`;
};

export const getDashboardURLWithMerchantCode = () => {
  if (!document) return '';
  const paramsObj = new URLSearchParams(document.location.search);
  return `${
    appLinks.carbonClickDashboardUrl
  }?business&merchantReferrerCode=${encodeURIComponent(
    paramsObj.get('merchantReferrerCode') || '',
  )}`;
};

export const getPaymentDefaultURL = () => {
  if (!document) return '';
  const paramsObj = new URLSearchParams(document.location.search);
  let paramsString = getParams(paramsObj);
  const baseURL = `${appLinks.carbonClickPaymentsUrl}?business`;

  return encodeURI(`${baseURL}${paramsString ? `&${paramsString}` : ''}`);
};

const getParams = (paramsObj: URLSearchParams): string => {
  let paramsString = Array.from(paramsObj.keys())
    .map((paramName: string): string => {
      const paramValue = paramsObj.get(paramName);
      if (paramValue === null) {
        throw Error(`Couldn't retrieve ${paramName} from ${location.search}`);
      }
      return `${paramName}=${encodeURIComponent(paramValue)}`;
    })
    .join('&');
  return paramsString;
};

export const createParamsFromInput = (
  estimationInputValues: EstimationInput,
) => {
  const additionalParamsString = Object.keys(estimationInputValues)
    // @ts-ignore
    .map(
      (paramName) =>
        // @ts-ignore
        `${paramName}=${encodeURIComponent(estimationInputValues[paramName])}`,
    )
    .join('&');

  return additionalParamsString;
};
